export enum BusinessType {
  FACILITY_ADMIN = "admin_created_staff",
  FACILITY_STAFF = "staff_created_staff",
}
